import {
    Box,
    Divider,
    Drawer,
    IconButton,
    Typography,
    styled,
} from '@mui/material';
import { elements } from '../elements';
import FormProviderWrapper from './Components/FormProviderWrapper';
import useSelectedElement from '@hooks/useSelectedElement';
import { useTranslation } from 'react-i18next';
import { ChevronLeftIcon } from '@Components/dir-icons';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
}));

function AttributesPanel() {
    const { t } = useTranslation();
    const { getSelectedElement, deselectElement } = useSelectedElement();
    const [selectedElementNode, selectedElementPath] = getSelectedElement();

    if (!selectedElementNode) return null;

    const nodeType = selectedElementNode.type;
    const Panel = nodeType && elements?.[nodeType]?.panel;

    const title = t(elements?.[nodeType]?.panelTitle);

    return (
        <Drawer
            variant="permanent"
            open
            PaperProps={{
                sx: {
                    position: 'absolute',
                },
            }}
        >
            <DrawerHeader>
                <div style={{ width: 32 }} />
                <Typography variant="h6">{title}</Typography>
                <IconButton onClick={() => deselectElement()}>
                    <ChevronLeftIcon />
                </IconButton>

                {/* <Typography variant="caption" sx={{ float: 'right' }}>
                    {JSON.stringify(selectedElementPath)}
                </Typography> */}
            </DrawerHeader>
            <Divider />
            <Box
                overflow="auto"
                height="100%"
                sx={{
                    width: theme => theme.spacing(40),
                }}
            >
                {Panel && (
                    <FormProviderWrapper>
                        <Panel />
                    </FormProviderWrapper>
                )}
            </Box>
        </Drawer>
    );
}

export default AttributesPanel;
